export enum InventoryAdjustmentStatusEnum {
  IN_PROGRESS = 'in-progress',
  UPDATING = 'updating',
  UPDATE_FAILED = 'update-failed',
  COMPLETED = 'completed',
}

export enum InventoryAdjustmentSearchCriteriaEnum {
  ALL = 'all',
  IN_PROGRESS = 'in-progress',
  UPDATING = 'updating',
  UPDATE_FAILED = 'update-failed',
  COMPLETED = 'completed',
}
